import { Content } from "@/components/layouts/content";
import { Header } from "@/components/layouts/header";
import { createFileRoute } from "@tanstack/react-router";
import ReactMarkdown from "react-markdown";
import changelog from "../../../CHANGELOG.md?raw";

export const Route = createFileRoute("/_dashboard/changelogs")({
	component: RouteComponent,
});

function RouteComponent() {
	return (
		<Content pageName="Changelogs">
			<div className="flex flex-col w-full max-w-[1200px] p-6">
				<div id="markdown" className="flex flex-col w-full gap-3">
					<ReactMarkdown>{changelog}</ReactMarkdown>
				</div>
			</div>
		</Content>
	);
}
